import type { LocationCreateProps } from "./location-create.type";
import type { LocationCreatePayload } from "@/entities/location";
import type { LocationFormValues } from "@/modules/location/location-form/";

import { useTranslation } from "react-i18next";

import { useCreateLocation } from "@/entities/location";
import { useNavigateToRessource } from "@/hooks/useNavigateToRessource";
import LocationForm from "@/modules/location/location-form";
import { MAP_DEFAULT_CENTER_STRING } from "@/modules/map";

const LocationCreate = ({
  parentOrganization,
  parentLocation,
}: LocationCreateProps) => {
  const { t } = useTranslation();

  const mutation = useCreateLocation();
  const saveButtonLabel = t("global:add");

  const initialValues: LocationFormValues = {
    name: "",
    description: "",
    coordinate: MAP_DEFAULT_CENTER_STRING,
    organization: {
      value: parentOrganization?.id,
      label: parentOrganization?.name,
      key: parentOrganization?.id,
    },
  };

  if (parentLocation) {
    initialValues.location = {
      value: parentLocation.id,
      label: parentLocation.name,
      key: parentLocation.id,
    };
    if (parentLocation.coordinate) {
      initialValues.coordinate = parentLocation.coordinate;
    }
  }

  const onNavigateToLocation = useNavigateToRessource<LocationCreatePayload>(
    "/locations/{{id}}",
    (response) => response.data.data.id
  );

  return (
    <LocationForm
      mutation={mutation}
      saveButtonLabel={saveButtonLabel}
      initialValues={initialValues}
      onMutate={onNavigateToLocation}
      isSector={!!parentLocation} // Indicate this is a sector creation
    />
  );
};

export default LocationCreate;
